import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Trash } from '../../../internal/icons/small/Trash';
import { IconButton } from '../../IconButton';
import { Typography } from '../../Typography';
import { Clear } from '../../../internal/icons/small/Clear';
export var useStyles = makeStyles(function (theme) {
    var defaultBackgroundColor = theme.palette.type === 'light' ? theme.palette.background.paper : theme.palette.background.b1;
    return createStyles({
        fileRoot: {
            alignItems: 'stretch',
            backgroundColor: defaultBackgroundColor,
            display: 'flex',
            minHeight: '38px',
        },
        fileContent: {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            flexGrow: 1,
            gridGap: '8px',
            padding: '8px 12px',
        },
        fileIcon: {
            alignItems: 'center',
            display: 'flex',
            flexShrink: 0,
            height: '24px',
            marginRight: '8px',
        },
        fileLabel: {
            flexGrow: 1,
        },
    });
});
export var FileUploaded = function (props) {
    var file = props.file, fileIcon = props.fileIcon, fileLabel = props.fileLabel, fileSetter = props.fileSetter, removeIcon = props.removeIcon, removeLabel = props.removeLabel, fileInputRef = props.fileInputRef, error = props.error, errorTitle = props.errorTitle;
    var classes = useStyles(props);
    function handleRemove() {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        fileSetter === null || fileSetter === void 0 ? void 0 : fileSetter(undefined);
    }
    var initialIcon = function () {
        if (error) {
            return React.createElement(Clear, { color: "error" });
        }
        return fileIcon && React.createElement("div", { className: classes.fileIcon }, fileIcon(file));
    };
    return (React.createElement("div", { className: classes.fileRoot },
        React.createElement("div", { className: classes.fileContent },
            initialIcon(),
            React.createElement("div", { className: classes.fileLabel },
                React.createElement(Typography, { variant: "subtitle2", component: "span" }, fileLabel(file)),
                error && (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement(Typography, { color: "error", variant: "subtitle2", component: "span" }, errorTitle))))),
        React.createElement(IconButton, { "aria-label": removeLabel, onClick: handleRemove }, removeIcon !== null && removeIcon !== void 0 ? removeIcon : React.createElement(Trash, null))));
};
//# sourceMappingURL=FileUploader.fileUploaded.js.map